<div class="w-full h-full flex flex-col items-center">
  <p class="text-secondary-900 dark:text-white mb-4 text-2xl">Reset Password Email Sent</p>
  <p class="text-secondary-500 dark:text-secondary-300 text-lg mb-10 text-center">Check your inbox</p>
  <axle-primary-button text="Return to Login" size="large" class="w-full px-3" (clicked)="login()"></axle-primary-button>
</div>
